import { Component } from '@theme/component';

/**
 * Toggle for the "Show more / Show less" affordance on the copy intro section.
 * Flips the truncation class on the copy wrap and the button's `aria-expanded`.
 *
 * @typedef {object} Refs
 * @property {HTMLElement} wrap - The copy wrapper that gets the truncation class toggled.
 * @property {HTMLButtonElement} toggleButton - The show-more/show-less button.
 *
 * @extends {Component<Refs>}
 */
class CopyIntro extends Component {
  /**
   * Toggle handler bound to the show-more button via `on:click="/toggle"`.
   * The framework only passes the event, so the button comes from refs.
   *
   * @returns {void}
   */
  toggle() {
    const wasTruncated = this.refs.wrap.classList.contains('ts-copy-intro__copy-wrap--truncated');
    this.refs.wrap.classList.toggle('ts-copy-intro__copy-wrap--truncated', !wasTruncated);
    this.refs.toggleButton.setAttribute('aria-expanded', String(wasTruncated));
  }
}

if (!customElements.get('ts-copy-intro')) {
  customElements.define('ts-copy-intro', CopyIntro);
}
